import { type FunctionComponent } from 'react'
import { FilterDisclosure } from '@vtex/admin-ui'

import { type GenericFilterStateReturn } from '../types'

import { useBaseFilterState } from './hooks/useBaseFilterState'

export interface BaseFilterProps<T, V extends GenericFilterStateReturn<T>> {
  useFilterState: (key: string) => V
  FilterPopoverComponent: FunctionComponent<{ state: V }>
  filterName: string
  disclosureMessage: string
  toSerializableData: (state: V) => unknown
  keepMounted?: boolean
}

export function BaseFilter<T, V extends GenericFilterStateReturn<T>>(
  props: BaseFilterProps<T, V>
) {
  const {
    useFilterState,
    FilterPopoverComponent,
    filterName,
    disclosureMessage,
    toSerializableData,
    keepMounted,
  } = props

  const state = useBaseFilterState<T, V>({
    filterName,
    useFilterState,
    toSerializableData,
  })

  return (
    <>
      <FilterDisclosure state={state}>{disclosureMessage}</FilterDisclosure>
      {keepMounted ? (
        <FilterPopoverComponent state={state} />
      ) : (
        state.menu.mounted && <FilterPopoverComponent state={state} />
      )}
    </>
  )
}
